var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upselling-footer"},[_c('p',[_vm._v(_vm._s(_vm.body))]),_c('a',{on:{"click":_vm.clickHandler}},[(_vm.prefix)?_c('i',{staticClass:"nexd-icon-16-chat"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.link))]),(_vm.suffix)?_c('i',{staticClass:"nexd-icon-16-chat"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }